<template>
  <div>
    <h1 class="text-xl mb-8">我的订单</h1>

    <Placeholder v-if="!orders" />
    <div v-else-if="!orders.length">
      <div class="ui info message">
        没有订单
      </div>
    </div>
    <div v-else>
      <table class="ui very basic compact table filelist nowrap">
        <thead v-if="screen_md">
          <tr>
            <th>订单号</th>
            <th>套餐</th>
            <th>有效期</th>
            <th>支付金额 (元)</th>
            <th>状态</th>
            <th>创建时间</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders" :key="order.tid">
            <td>
              <a class="text-blue-500" @click="$router.push({ name: 'order', query: { tid: order.tid }})">{{ order.tid }}</a>
            </td>
            <td>
              <span v-if="order.plan">
                {{ order.plan.display_name }}
              </span>
            </td>
            <td>
              <template v-if="order.start && order.expire">
                {{ format_time(order.start) }} ~ {{ format_time(order.expire) }}
              </template>
              <template v-else>
                无
              </template>
            </td>
            <td>
              {{ order.amount }}
            </td>
            <td>
              <span v-if="order.refund && order.refund.rejected">
                退款失败
              </span>
              <span v-else-if="order.refund && order.refund.refunded" class="text-green-500">
                已退款
              </span>
              <span v-else-if="order.refund" class="text-gray-600">
                退款处理中
              </span>
              <span v-else-if="order.paid" class="text-green-600">
                已成功
              </span>
              <span v-else class="text-orange-500 font-bold">
                待支付
              </span>
            </td>
            <td>
              {{ order_time(order) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Placeholder from '../components/placeholder.vue';
import printf from 'printf';

export default {
  name: 'OrderListPage',
  props: [],
  components: {
    Placeholder,
  },
  data: function () {
    return {
      orders: null,
    };
  },
  computed: {
  },
  methods: {
    order_time(order) {
      var e = new Date(order.create_time * 1000);
      return printf("%d-%02d-%02d %02d:%02d",
        e.getFullYear(), e.getMonth() + 1, e.getDate(),
        e.getHours(), e.getMinutes(),
      );
    },
  },
  async mounted() {
    this.orders = await this.client.fetch_orders();
    this.orders.sort((a, b) => b.create_time - a.create_time);
  },
}
</script>

<style scoped>
th {
  border: 0px;
}
</style>
